module.exports = __webpack_public_path__ + "img/icn-start.7d1373b4.svg";